class PrintButton {
    constructor(el) {
        this.el = el;
        this.activeClass = 'print-active';
        this.activeClassBody = 'body-print-active';
        this.body = document.querySelector('body');
        this.printId = el.getAttribute('data-print-id')
        this.printedElement = document.getElementById(this.printId);
        this.init();
    }

    init () {
        this.el.addEventListener('click', (e) => {
            e.preventDefault();
            this.body.classList.add(this.activeClassBody);
            this.printedElement.classList.add(this.activeClass);
            this.setAfterPrint();
            window.print();
        });
    }

    setAfterPrint () {
        // Not webkit
        if (! window.matchMedia) {
            window.onafterprint = () => {
                if (this.body.classList.contains(this.activeClassBody)) {
                    this.doAfterPrint();
                }
            };
        } else {
            // webkit
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener((mql) => {
                if (! mql.matches) {
                    // on afterprint
                    if (this.body.classList.contains(this.activeClassBody)) {
                        this.doAfterPrint();
                    }
                }
            });
        }
    }

    doAfterPrint () {
        this.printedElement.classList.remove(this.activeClass);
        this.body.classList.remove(this.activeClassBody);
        this.printedElement.scrollIntoView();
    }
}

export default PrintButton;
